<template>
  <v-container fluid fill-height justify-center
    align-center>
   <v-flex xs12 sm10 md8>
    <v-card class="elevation-1">
      <v-toolbar color="primary">
        <v-toolbar-title class="white--text">Insurance Plans</v-toolbar-title>
      </v-toolbar>
      <v-flex>
        <v-data-table
            v-bind:headers="headers"
            v-bind:items="items"
            hide-actions
            :loading="loading"
            no-data-text="Loading plans."
            :rows-per-page-items="rows"
            :pagination.sync="pagination"
            
          >
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ props.item.short_name }}</td>
            <td>
               {{ props.item.name }}
            </td>
            <td>
                <v-layout align-center>
                  <v-flex>
                    <v-btn 
                      @click="showPlan(props.item)" 
                      small 
                      dark color="primary"
                      >
                      show
                      </v-btn>
                  </v-flex>
                  <v-flex>
                    <v-btn 
                      @click="editPlan(props.item)" 
                      small 
                      dark
                      >edit
                      </v-btn>
                  </v-flex>
                </v-layout>
              
              </td>
            
          </template>
        </v-data-table>
      </v-flex>
    </v-card>
  </v-flex>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      max25chars: v => v.length <= 25 || "Input too long!",
      tmp: "",
      search: "",
      pagination: {},
      rows: [10, 15, 25, { text: "All", value: -1 }],
      loading: true,
      headers: [
        {
          text: "Short Name",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name"
        }
      ],
      items: []
    };
  },
  methods: {
    editPlan(item) {
      this.$router.push({ path: `/admin/plans/edit/${item.id}` });
    },
    showPlan(item) {
      this.$router.push({ path: `/admin/plans/show/${item.id}` });
    }
  },
  mounted() {
    axios.get("/insuranceplans").then(response => {
      this.items = response.data.insurancePlans;
      this.loading = false;
    });
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/Plans/Plans.vue